import { Component, Input, OnInit } from '@angular/core';
import { RedemptionCodeSet, RedemptionCodeSetStatus } from '../../../../../../../../models/redemption-code';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RedemptionCodeService } from '../../../../../../../../services/redemption-code/redemption-code.service';


enum ModalActions {
  ChangeExpiration,
  RemoveExpiration,
  ExpireImmediately
}


@Component({
  selector: 'app-edit-redemption-code-set-expiration-modal',
  templateUrl: './edit-redemption-code-set-expiration-modal.component.html',
  styleUrls: ['./edit-redemption-code-set-expiration-modal.component.css']
})
export class EditRedemptionCodeSetExpirationModalComponent implements OnInit {
  @Input() redemptionCodeSet: RedemptionCodeSet;
  @Input() savedCallback: () => undefined;

  public modalAction = ModalActions.ChangeExpiration;
  public expirationDate = '';

  public loadingSubmit = false;

  public errorMessage = '';
  public serverError: number = null;

  public readonly ModalAction = ModalActions;
  public readonly RedemptionCodeSetStatus = RedemptionCodeSetStatus;

  constructor(
    public activeModal: NgbActiveModal,
    private redemptionCodeService: RedemptionCodeService,
  ) {}

  ngOnInit() {
    if (this.redemptionCodeSet.expiration_date) {
      this.expirationDate = this.redemptionCodeSet.expiration_date;
    }
  }

  public handleSubmit() {
    this.loadingSubmit = true;

    let savePromise: Promise<void>;

    switch (this.modalAction) {
      case ModalActions.ChangeExpiration:
        savePromise = this.redemptionCodeService
          .changeRedemptionCodeSetExpiration(
            this.redemptionCodeSet.id,
            this.expirationDate
          );
        break;
      case ModalActions.RemoveExpiration:
        savePromise = this.redemptionCodeService
          .removeRedemptionCodeSetExpiration(
            this.redemptionCodeSet.id
          );
        break;
      case ModalActions.ExpireImmediately:
        savePromise = this.redemptionCodeService
          .expireRedemptionCodeSetImmediately(
            this.redemptionCodeSet.id
          );
        break;
    }

    savePromise
      .then(() => {
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public submitAvailable() {
    if (this.modalAction === ModalActions.ChangeExpiration) {
      if (!this.expirationDate) {
        return false;
      }
    }

    return true;
  }
}
